import create from 'zustand';

type LoaderScreenProps = {
  open: boolean;
};

export const useLoaderScreen = create<LoaderScreenProps>(() => ({
  open: false,
}));
